<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información de la Empresa">
          <b-form>
            <b-form-group
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                v-model.trim="$v.razonSocial.$model" 
                :state="razonSocialValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="razonSocialFeedback">
                {{ razonSocialInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                v-model.trim="$v.nombreComercial.$model" 
                :state="nombreComercialValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreComercialFeedback">
                {{ nombreComercialInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Pais"
              label-for="pais"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pais"
                :value="pais" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Condición Fiscal"
              label-for="condicionFiscal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="condicionFiscal"
                v-model.trim="$v.condicionFiscal.$model" 
                :state="condicionFiscalValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="condicionFiscalFeedback">
                {{ condicionFiscalInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Tipo Documento"
              label-for="tipoDocumento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="tipoDocumento"
                v-model.trim="$v.tipoDocumento.$model" 
                :state="tipoDocumentoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="tipoDocumentoFeedback">
                {{ tipoDocumentoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nro. Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="II.BB"
              label-for="ingresosBrutos"
              :label-cols="labelCols"
              description="Nro de inscripción en Ingresos Brutos"
              horizontal>
              <b-form-input 
                id="ingresosBrutos"
                v-model.trim="$v.ingresosBrutos.$model" 
                :state="ingresosBrutosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="ingresosBrutosFeedback">
                {{ ingresosBrutosInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Inicio"
              label-for="fechaInicioActividades"
              description="Fecha de inicio de actividades"
              :label-cols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="fechaInicioActividadesHabilitada"
                      v-model="fechaInicioActividadesHabilitada"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="fechaInicioActividades" 
                  v-model="$v.fechaInicioActividades.$model" 
                  type="date"
                  :disabled="fechaInicioActividadesDisabled"
                  :state="fechaInicioActividadesValida"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="fechaInicioActividadesFeedback">
                {{ fechaInicioActividadesInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="CUIT"
              label-for="cuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuit"
                v-model.trim="$v.cuit.$model" 
                :state="cuitValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuitFeedback">
                {{ cuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->

            <b-form-group
              label="Dirección"
              label-for="direccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccion"
                v-model.trim="$v.direccion.$model" 
                :state="direccionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionFeedback">
                {{ direccionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Teléfono"
              label-for="telefono"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="telefono"
                v-model.trim="$v.telefono.$model" 
                :state="telefonoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="telefonoFeedback">
                {{ telefonoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Sitio Web"
              label-for="website"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="website"
                v-model.trim="$v.website.$model" 
                :state="websiteValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="websiteFeedback">
                {{ websiteInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU"
              label-for="cbu"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbu"
                v-model.trim="$v.cbu.$model" 
                :state="cbuValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuFeedback">
                {{ cbuInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU Alias"
              label-for="cbuAlias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbuAlias"
                v-model.trim="$v.cbuAlias.$model" 
                :state="cbuAliasValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuAliasFeedback">
                {{ cbuAliasInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header= "Sucursal">
          <b-form>
            <b-form-group
              label="Título"
              label-for="sucursalTitulo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="sucursalTitulo"
                v-model.trim="$v.sucursalTitulo.$model" 
                :state="sucursalTituloValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="sucursalTituloFeedback">
                {{ sucursalTituloInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Dirección"
              label-for="sucursalDireccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="sucursalDireccion"
                v-model.trim="$v.sucursalDireccion.$model" 
                :state="sucursalDireccionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="sucursalDireccionFeedback">
                {{ sucursalDireccionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header= "Emails Transaccionales">
          <b-form>
            <b-form-group
              label="Email Proveedores"
              label-for="emailProveedores"
              :label-cols="labelCols"
              description="Cuenta de correo para órdenes a proveedores"
              horizontal>
              <b-form-input 
                id="emailProveedores"
                v-model.trim="$v.emailProveedores.$model" 
                :state="emailProveedoresValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailProveedoresFeedback">
                {{ emailProveedoresInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'empresa/getField',
  mutationType: 'empresa/updateField',
});

/* Validamos CBU solo para Arg */
const CBU = ((value, vm) => {
  if (value == '' || vm.paisId != 1) {
    return true;
  } else {
    if (!isNaN(parseInt(value))) {
      if ((value.length == 1 && parseInt(value) == 0) || value.length == 22) {
        return true;
      }
    }
  }

  return false;
})

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreComercialValido: null,
      nombreComercialInvalidoMsj: '',
      razonSocialValida: null,
      razonSocialInvalidaMsj: '',
      condicionFiscalValida: null,
      condicionFiscalInvalidaMsj: '',
      tipoDocumentoValido: null,
      tipoDocumentoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      ingresosBrutosValido: null,
      ingresosBrutosInvalidoMsj: '',
      fechaInicioActividadesValida: null,
      fechaInicioActividadesInvalidaMsj: '',
      // cuitValido: null,
      // cuitInvalidoMsj: '',
      direccionValida: null,
      direccionInvalidaMsj: '',
      telefonoValido: null,
      telefonoInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      websiteValido: null,
      websiteInvalidoMsj: '',
      cbuValido: null,
      cbuInvalidoMsj: '',
      cbuAliasValido: null,
      cbuAliasInvalidoMsj: '',
      sucursalTituloValido: null,
      sucursalTituloInvalidoMsj: '',
      sucursalDireccionValida: null,
      sucursalDireccionInvalidaMsj: '',
      emailProveedoresValido: null,
      emailProveedoresInvalidoMsj: '',

      fechaInicioActividadesDisabled: true,

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'nombreComercial',
      'razonSocial',
      'condicionFiscal',
      'tipoDocumento',
      'documentoNumero',
      'ingresosBrutos',
      'fechaInicioActividades',
      'fechaInicioActividadesHabilitada',
      // 'cuit',
      'paisId',
      'pais',
      'direccion',
      'telefono',
      'email',
      'website',
      'cbu',
      'cbuAlias',
      'sucursalTitulo',
      'sucursalDireccion',
      'emailProveedores'
    ])
  },  
  created() {
    this.getDatos();
  },  
  methods: {
    getDatos(){
      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then (() => {
          if (moment(this.fechaInicioActividades).format('YYYY-MM-DD') == '1900-01-01') {
            this.fechaInicioActividadesDisabled = true;
          } else {
            this.fechaInicioActividadesDisabled = false;
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombreComercial' || validarTodos) {
        if (this.$v.nombreComercial.$error) {
          this.nombreComercialValido = false;
          if (!this.$v.nombreComercial.required) {
            this.nombreComercialInvalidoMsj= 'Debe ingresar el nombre comercial.';
          } else if (!this.$v.nombreComercial.maxLength) {
            this.nombreComercialInvalidoMsj = 'El nombre comercial solo puede contener hasta 150 caracteres';
          } 
        } else {
          this.nombreComercialValido = null;
          this.nombreComercialInvalidoMsj = '';
        }
      }
        
      if (campo == 'razonSocial' || validarTodos) {
        if (this.$v.razonSocial.$error) {
          this.razonSocialValida = false;
          if (!this.$v.razonSocial.required) {
            this.razonSocialInvalidaMsj = 'Debe ingresar la razón social.';
          } else if (!this.$v.razonSocial.maxLength) {
            this.razonSocialInvalidaMsj = 'La razón social solo puede contener hasta 150 caracteres';
          }
        } else {
          this.razonSocialValida = null;
          this.razonSocialInvalidaMsj = '';
        }
      }

      if (campo == 'condicionFiscal' || validarTodos) {
        if (this.$v.condicionFiscal.$error) {
          this.condicionFiscalValida = false;
          if (!this.$v.condicionFiscal.required) {
            this.condicionFiscalInvalidaMsj = 'Debe ingresar la condición fiscal.';
          } else if (!this.$v.condicionFiscal.maxLength) {
            this.condicionFiscalInvalidaMsj = 'La condición fiscal solo puede contener hasta 150 caracteres';
          }
        } else {
          this.condicionFiscalValida = null;
          this.condicionFiscalInvalidaMsj = '';
        }
      }

      if (campo == 'tipoDocumento' || validarTodos) {
        if (this.$v.tipoDocumento.$error) {
          this.tipoDocumentoValido = false;
          if (!this.$v.tipoDocumento.required) {
            this.tipoDocumentoInvalidoMsj = 'Debe ingresar el tipo de documento.';
          } else if (!this.$v.tipoDocumento.maxLength) {
            this.tipoDocumentoInvalidoMsj = 'El tipo de documento solo puede contener hasta 50 caracteres';
          }
        } else {
          this.tipoDocumentoValido = null;
          this.tipoDocumentoInvalidoMsj = '';
        }
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false;
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el número de documento.';
          } else if (!this.$v.documentoNumero.maxLength) {
            this.documentoNumeroInvalidoMsj = 'El número de documento solo puede contener hasta 20 caracteres';
          }
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'ingresosBrutos' || validarTodos) {
        if (this.$v.ingresosBrutos.$error) {
          this.ingresosBrutosValido = false;
          if (!this.$v.ingresosBrutos.maxLength) {
            this.ingresosBrutosInvalidoMsj = 'El número de inscripción solo puede contener hasta 15 caracteres';
          }
        } else {
          this.ingresosBrutosValido = null;
          this.ingresosBrutosInvalidoMsj = '';
        }
      }

      // if (campo == 'cuit' || validarTodos) {
      //   if (this.$v.cuit.$error) {
      //     this.cuitValido = false;
      //     if (!this.$v.cuit.required) {
      //       this.cuitInvalidoMsj = 'Debe ingresar el CUIT.';
      //     } else if (!this.$v.cuit.maxLength) {
      //       this.cuitInvalidoMsj = 'El CUIT solo puede contener hasta 15 caracteres.';
      //     }      
      //   } else {
      //     this.cuitValido = null;
      //     this.cuitInvalidoMsj = '';
      //   }
      // }

      if (campo == 'direccion' || validarTodos) {
        if (this.$v.direccion.$error) {
          this.direccionValida = false;
          if (!this.$v.direccion.maxLength) {
            this.direccionInvalidaMsj = 'La dirección solo puede contener hasta 250 caracteres.';
          }      
        } else {
          this.direccionValida = null;
          this.direccionInvalidaMsj = '';
        }
      }

      if (campo == 'telefono' || validarTodos) {
        if (this.$v.telefono.$error) {
          this.telefonoValido = false;
          if (!this.$v.telefono.maxLength) {
            this.telefonoInvalidoMsj = 'El número de teléfono solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.telefonoValido = null;
          this.telefonoInvalidoMsj = '';
        }
      }
          
      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false
          if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }

      if (campo == 'website' || validarTodos) {
        if (this.$v.website.$error) {
          this.websiteValido = false
          if (!this.$v.website.maxLength) {
            this.websiteInvalidoMsj = 'El sitio web solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.websiteValido = null;
          this.websiteInvalidoMsj = '';
        }
      }

      if (campo == 'cbu' || validarTodos) {
        if (this.$v.cbu.$error) {
          this.cbuValido = false;
          if (!this.$v.cbu.CBU) {
            this.cbuInvalidoMsj = 'Verifique por favor el CBU ingresado.';
          }      
        } else {
          this.cbuValido = null;
          this.cbuInvalidoMsj = '';
        }
      }

      if (campo == 'cbuAlias' || validarTodos) {
        if (this.$v.cbuAlias.$error) {
          this.cbuAliasValido = false;
          if (!this.$v.cbuAlias.maxLength) {
            this.cbuAliasInvalidoMsj = 'El alias de CBU solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.cbuAliasValido = null;
          this.cbuAliasInvalidoMsj = '';
        }
      }

      if (campo == 'sucursalTitulo' || validarTodos) {
        if (this.$v.sucursalTitulo.$error) {
          this.sucursalTituloValido = false
          if (!this.$v.sucursalTitulo.maxLength) {
            this.sucursalTituloInvalidoMsj = 'El título de la sucursal solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.sucursalTituloValido = null;
          this.sucursalTituloInvalidoMsj = '';
        }
      }

      if (campo == 'sucursalDireccion' || validarTodos) {
        if (this.$v.sucursalDireccion.$error) {
          this.sucursalDireccionValida = false
          if (!this.$v.sucursalDireccion.maxLength) {
            this.sucursalDireccionInvalidaMsj = 'La dirección de la sucursal solo puede contener hasta 250 caracteres.';
          }      
        } else {
          this.sucursalDireccionValida = null;
          this.sucursalDireccionInvalidaMsj = '';
        }
      }

      if (campo == 'emailProveedores' || validarTodos) {
        if (this.$v.emailProveedores.$error) {
          this.emailProveedoresValido = false
          if (!this.$v.emailProveedores.email) {
            this.emailProveedoresInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.emailProveedores.maxLength) {
            this.emailProveedoresInvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.emailProveedoresValido = null;
          this.emailProveedoresInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('empresa/save')
          .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.getDatos, this.getDatos, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      } 
    },
    goBack() {
      this.getDatos();
    },
  },
  watch: {
    'fechaInicioActividadesHabilitada' : function(newVal, oldVal) {
      this.fechaInicioActividadesDisabled = !(/true/i).test(this.fechaInicioActividadesHabilitada);
    },
  },
  validations: {
    nombreComercial: {
      required,
      maxLength: maxLength(150)
    },
    razonSocial: {
      required,
      maxLength: maxLength(150)
    },
    condicionFiscal: {
      maxLength: maxLength(150)
    },
    tipoDocumento: {
      required,
      maxLength: maxLength(50)
    },
    documentoNumero: {
      required,
      maxLength: maxLength(20)
    },
    ingresosBrutos: {
      maxLength: maxLength(15)
    },
    fechaInicioActividades: {},
    // cuit: {
    //   required,
    //   maxLength: maxLength(15)
    // },
    direccion: {
      maxLength: maxLength(250)
    },
    telefono: {
      maxLength: maxLength(150)
    },
    website: {
      maxLength: maxLength(150)
    },
    email: {
      email,
      maxLength: maxLength(150)
    },
    cbu: {
      CBU
    },
    cbuAlias: {
      maxLength: maxLength(150)
    },
    sucursalTitulo: {
      maxLength: maxLength(50)
    },
    sucursalDireccion: {
      maxLength: maxLength(250)
    },
    emailProveedores: {
      email,
      maxLength: maxLength(150)
    },
  },  
}
</script>

<style>
</style>
